import type { ReactNode } from 'react';
import type { LucideIcon } from 'lucide-react';

export type WidgetCategory =
  | 'kpi'
  | 'overdue'
  | 'anaf'
  | 'sales'
  | 'cashflow'
  | 'ops'
  | 'ai';

export type WidgetSize = 'S' | 'M' | 'L' | 'XL' | 'Full';

export interface WidgetDefinition {
  id: string;
  title: string;
  description: string;
  category: WidgetCategory;
  /** Dimensiune standardizată — mapată la w,h în SIZE_DIMS */
  size: WidgetSize;
  /** @deprecated — se păstrează temporar pentru componente care încă îl citesc. */
  defaultSpan?: number;
  /** @deprecated — înlocuit de size */
  defaultRow?: number;
  /** Override manual pentru dimensiuni (h, w, minH etc.) când preset-ul size nu se potrivește */
  sizeOverride?: { w?: number; h?: number; minW?: number; maxW?: number; minH?: number; maxH?: number };
  /** Mark as NEW in picker. */
  isNew?: boolean;
  /** Icon shown in widget header + picker. */
  icon?: LucideIcon;
  /** React component rendering the widget body (without card wrapper). */
  Component: () => ReactNode;
}

export interface DashboardLayout {
  /** Ordered list of widget IDs currently visible. */
  visible: string[];
  /** Widget IDs explicitly hidden by user. */
  hidden: string[];
  /** Per-widget overrides (span etc). Future. */
  overrides?: Record<string, { span?: number; row?: number }>;
}

export const CATEGORY_LABELS: Record<WidgetCategory, string> = {
  kpi: 'KPI Financiar',
  overdue: 'Risc & Overdue',
  anaf: 'ANAF & Compliance',
  sales: 'Vânzări & Trends',
  cashflow: 'Cash Flow & Prognoze',
  ops: 'Operații & Productivitate',
  ai: 'AI & Insights',
};
